<script lang="ts">
	import type { SavedAttachmentFile } from '@isoftdata/svelte-attachments'

	import { v4 as uuid } from '@lukeed/uuid'
	import { Table, ObjectViewerModal } from '@isoftdata/svelte-attachments'
	import ImageViewerModal from '@isoftdata/svelte-image-viewer'

	interface Attachment {
		readonly id: number
		readonly public: boolean
		readonly rank: number | null
		readonly file: {
			readonly id: number
			readonly name: string
			readonly path: string
			readonly mimetype: string
			readonly size: number
		}
	}

	interface Props {
		attachments?: Array<Attachment>
	}

	let { attachments = [] }: Props = $props()

	let fileToView: SavedAttachmentFile | undefined = $state(undefined)
	let showObjectViewerModal: boolean = $state(false)
	let showImageViewerModal: boolean = $state(false)
	let filePaths: Array<string> = $state([])
	let index: number = $state(0)

	function attachmentClicked(file: SavedAttachmentFile) {
		const isImageFile = file.mimeType.startsWith('image/')
		if (isImageFile) {
			openImageViewerModal(file.fileId)
		} else {
			openObjectViewerModal(file)
		}
	}

	function openObjectViewerModal(file: SavedAttachmentFile) {
		showObjectViewerModal = true
		fileToView = file
	}

	export function openImageViewerModal(fileId: number) {
		const imageFiles = attachmentsTableFileList.filter(file => file.mimeType.startsWith('image/'))
		filePaths = imageFiles.reduce((acc: Array<string>, attachment) => {
			return attachment.path ? [...acc, attachment.path] : acc
		}, [])
		index = imageFiles.findIndex(file => file.fileId === fileId)
		showImageViewerModal = attachmentsTableFileList.length > 0
		fileToView = imageFiles[index]
	}

	const attachmentsTableFileList: Array<SavedAttachmentFile> = $derived(
		attachments.map(attachment => {
			return {
				fileId: attachment.id,
				public: attachment.public,
				rank: attachment.rank || 1,
				mimeType: attachment.file.mimetype,
				name: attachment.file.name,
				size: attachment.file.size,
				path: attachment.file.path,
				uuid: uuid(),
			}
		}),
	)
</script>

<Table
	modificationDisabled
	fileList={attachmentsTableFileList}
	rowClick={ctx => {
		if (ctx) {
			const file = attachmentsTableFileList.find(attachment => attachment.uuid === ctx.uuid)
			if (file) {
				attachmentClicked(file)
			}
		}
	}}
/>

{#if fileToView}
	<ImageViewerModal
		showIndicators={false}
		files={filePaths}
		bind:show={showImageViewerModal}
		bind:currentPhotoIndex={index}
	/>
	<ObjectViewerModal
		file={fileToView}
		bind:show={showObjectViewerModal}
	/>
{/if}
